<template>
  <div
    class="toggle-btn"
    :style="{ 'background-color': color ? pallette[color] : pallette.primary100 }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { pallette } from "@/utils/colors";

defineProps<{
  modelValue: string;
  color?: keyof typeof pallette;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
.toggle-btn {
  width: fit-content;
  padding: 5px;
  border-radius: 8px;

  :deep(button) {
    padding: 7px 15px;
  }
  :deep(.current) {
    background-color: $white;
    border-radius: 4px;
  }
}
</style>
